/**
 * @generated SignedSource<<94f9b962bde732f64d7ba700f9b50f53>>
 * @relayHash 855634883f009c08bdfaebe74d78383c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 471698f9977dba0edd36d9ed6c459e88b174645e1a208f8010ac892b0c6f3a87

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraForgeEnvironmentType = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type JiraVisibilityControlMechanism = "AppAccessRules" | "DisplayConditions" | "%future added value";
export type JiraExtensionRenderingContextInput = {
  issueKey?: string | null | undefined;
  portalId?: string | null | undefined;
  projectKey?: string | null | undefined;
};
export type useExtensionsQuery$variables = {
  cloudId: string;
  context: JiraExtensionRenderingContextInput;
  includeEgressOverridesForge: boolean;
  includeHidden: boolean;
  types: ReadonlyArray<string>;
};
export type useExtensionsQuery$data = {
  readonly jira: {
    readonly forge: {
      readonly extensions: ReadonlyArray<{
        readonly appVersion: string;
        readonly consentUrl: string | null | undefined;
        readonly egress: ReadonlyArray<{
          readonly addresses: ReadonlyArray<string> | null | undefined;
          readonly category?: string | null | undefined;
          readonly inScopeEUD?: boolean | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined>;
        readonly environmentId: string;
        readonly environmentKey: string;
        readonly environmentType: JiraForgeEnvironmentType;
        readonly hiddenBy: JiraVisibilityControlMechanism | null | undefined;
        readonly id: string;
        readonly installationConfig?: ReadonlyArray<{
          readonly key: string;
          readonly value: boolean;
        }> | null | undefined;
        readonly installationId: string;
        readonly license: {
          readonly active: boolean;
          readonly billingPeriod: string | null | undefined;
          readonly capabilitySet: string | null | undefined;
          readonly ccpEntitlementId: string | null | undefined;
          readonly ccpEntitlementSlug: string | null | undefined;
          readonly isEvaluation: boolean | null | undefined;
          readonly subscriptionEndDate: AGG$DateTime | null | undefined;
          readonly supportEntitlementNumber: string | null | undefined;
          readonly trialEndDate: AGG$DateTime | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly overrides?: AGG$JSON | null | undefined;
        readonly properties: AGG$JSON;
        readonly type: string;
        readonly userAccess: {
          readonly hasAccess: boolean;
        } | null | undefined;
      }> | null | undefined;
    };
  } | null | undefined;
};
export type useExtensionsQuery = {
  response: useExtensionsQuery$data;
  variables: useExtensionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeEgressOverridesForge"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHidden"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "types"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraForgeQuery",
        "kind": "LinkedField",
        "name": "forge",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "context",
                "variableName": "context"
              },
              {
                "kind": "Variable",
                "name": "includeHidden",
                "variableName": "includeHidden"
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "types"
              }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hiddenBy"
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "environmentId"
              },
              {
                "kind": "ScalarField",
                "name": "environmentKey"
              },
              {
                "kind": "ScalarField",
                "name": "environmentType"
              },
              {
                "kind": "ScalarField",
                "name": "installationId"
              },
              {
                "kind": "ScalarField",
                "name": "appVersion"
              },
              {
                "kind": "ScalarField",
                "name": "consentUrl"
              },
              {
                "kind": "ScalarField",
                "name": "properties"
              },
              {
                "concreteType": "JiraUserAppAccess",
                "kind": "LinkedField",
                "name": "userAccess",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasAccess"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeAppEgressDeclaration",
                "kind": "LinkedField",
                "name": "egress",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "addresses"
                  },
                  (v5/*: any*/),
                  {
                    "condition": "includeEgressOverridesForge",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "category"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inScopeEUD"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeEgressOverridesForge",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "overrides"
                  },
                  {
                    "concreteType": "JiraForgeInstallationConfigExtension",
                    "kind": "LinkedField",
                    "name": "installationConfig",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraForgeExtensionLicense",
                "kind": "LinkedField",
                "name": "license",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "active"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "supportEntitlementNumber"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "subscriptionEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEvaluation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "billingPeriod"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementSlug"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "capabilitySet"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useExtensionsQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useExtensionsQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "471698f9977dba0edd36d9ed6c459e88b174645e1a208f8010ac892b0c6f3a87",
    "metadata": {},
    "name": "useExtensionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4021033be153a85f1f4bfd6f7a892a1";

export default node;
